import { useRouter } from 'next/router'
import Script from 'next/script'
import { useFullPageLoadFor } from '../hooks/useFullPageLoadFor'

const PIXEL_ID = '1444571937629471'

// Meta Pixel reports page views to Meta for ad targeting, so it only runs on
// pages listed here; a new page gets no pixel until it's added. Keep out the
// PA and verification tools (PHI), join-the-evry-network and
// RequestProviderForm (PII), the Lever iframe on /careers and auth redirects
// (/sign-in). Pages with ContactForm are allowed even though it collects name,
// email and phone: Meta only gets the page view, as long as autoConfig stays
// off below and Automatic Advanced Matching stays off in Meta Events Manager.
const PIXEL_ROUTES = [
  '/',
  '/admission-notification',
  '/clinical-practice-guidelines',
  '/community-resources',
  '/contact-us',
  '/faqs',
  '/forms',
  '/fwa',
  '/heartwalk',
  '/how-we-compare',
  '/how-we-do-it',
  '/meet-your-new-team',
  '/mobileapp',
  '/news',
  '/non-discrimination-policy',
  '/our-story',
  '/partners',
  '/prior-auth-list-updates',
  '/privacy-policy',
  '/request-to-join',
  '/retrospective-reviews',
  '/rewards',
  '/terms',
  '/virtual-care',
  '/why-choose-evry',
]

const isPixelRoute = (path) => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  return PIXEL_ROUTES.includes(pathname)
}

const isPixelLoaded = () =>
  typeof window !== 'undefined' &&
  Boolean(document.getElementById('meta-pixel-init'))

// Meta's script can report URL changes in its document, Back and Forward
// included, so a document running the pixel must never hold history entries
// for pages off the allowlist. A client-side route change across the allowlist
// boundary, in either direction, becomes a full page load.
const needsFullLoad = (url) => isPixelLoaded() !== isPixelRoute(url)

const MetaPixel = () => {
  const router = useRouter()
  const allowed = isPixelRoute(router.asPath)

  useFullPageLoadFor(needsFullLoad)

  if (!allowed) return null

  // autoConfig off stops Meta from collecting button clicks and page metadata
  // on its own. No user data is passed to init, so manual advanced matching is
  // off; automatic advanced matching is a setting in Meta Events Manager.
  return (
    <Script
      id="meta-pixel-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('set', 'autoConfig', false, '${PIXEL_ID}');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`,
      }}
    />
  )
}

export default MetaPixel
